var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('DESP-GERAIS-REQ-04') && _vm.permiteComprometer)?_c('b-button',{staticClass:"ml-2",attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarComprometer()}}},[_c('span',[_vm._v(" "+_vm._s(_vm.tituloBotao)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }